export default "__VITE_ASSET__622cf210__"